import React from 'react';
import MetricaBase from './MetricaBase';

const MetricaHierarquias = () => {
  return (
    <MetricaBase
      titulo="Distribuição por Grau de Hierarquia"
      descricao="Análise da distribuição de colaboradores ativos por nível hierárquico"
      endpoint="hierarquias"
      tipoDownload="hierarquias"
      cor="orange"
    />
  );
};

export default MetricaHierarquias;